import React from 'react'
import classes from './header.module.css';
import logo from '../../icon.jpg';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className={classes.container}>
            <div className={classes.logo_conatiner}>
                <img src={logo} width="40" height="40" alt="logo" className={classes.logo}/>
            </div>
            <Link className={classes.title} to="/">Expense Manager</Link>
        </div>
    )
}

export default Header
